const KeyMirror = require('keymirror');

module.exports = KeyMirror({
    LOAD_ORG_SUCCESS: true,
    LOAD_ORG_BEGIN: true,
    LOAD_ORG_ERROR: true,
});
